import { useTranslation } from "react-i18next";
import styles from "./styles.module.scss";

export const SubTitle = ({ text }) => {
  const { t } = useTranslation();

  return <h2 className={styles.subTitle}>{t(text)}</h2>;
};
